









import Vue from 'vue'
import { DeckType, CardType } from '../../models'
import { getCards } from '../../assets/utility'
import Card from './Card.vue'
import { firestore } from 'firebase'
import store from '../../store'
export default Vue.extend({
  name: 'Cards',
  components: {
    Card
  },
  data () {
    return {
      cards: [] as DeckType
    }
  },
  computed: {
    currentDeck () {
      return store.state.currentDeck
    }
  },
  watch: {
    currentDeck (newVal, oldVal) {
      // console.log('TCL: currentDeck -> newVal,oldVal', newVal, oldVal)
      if (newVal) {
        this.getCards(newVal)
      }
    }
  },
  methods: {
    async getCards (deckId:string) {
      let vm = this
      vm.cards = []
      try {
        let querySnapshot = await getCards(deckId)
        querySnapshot.forEach(function (doc:firestore.QueryDocumentSnapshot) {
          // console.log(doc.data())
          vm.cards.push(new CardType({ ...doc.data(), id: doc.id }))
          // vm.$set(vm.cards, doc.id, doc.data())
        })
        // console.log('TCL: getCards -> vm.cards', vm.cards)
      } catch (err) {
        console.log('TCL: getDecks -> err', err)
      }
    }
  }
})
